/**
 * Meta Pixel (browser side) — loaded only on pages that need it (/bewerbung).
 *
 * Every conversion event is sent with an explicit `eventID`. The server sends the
 * same event via the Conversions API with the same id → Meta deduplicates.
 */

let loadedPixelId = null;

export function loadMetaPixel(pixelId, pageViewEventId) {
  if (!pixelId || typeof window === 'undefined') return false;
  if (loadedPixelId === pixelId && window.fbq) return true;

  /* eslint-disable */
  if (!window.fbq) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }
  /* eslint-enable */

  window.fbq('init', pixelId);
  // Mit Event-ID, damit der Server denselben PageView melden kann und Meta beide
  // als ein Ereignis zusammenfuehrt statt doppelt zu zaehlen.
  if (pageViewEventId) window.fbq('track', 'PageView', {}, { eventID: pageViewEventId });
  else window.fbq('track', 'PageView');
  loadedPixelId = pixelId;
  return true;
}

export function isPixelLoaded() {
  return !!(loadedPixelId && window.fbq);
}

/**
 * Erweiterter Abgleich („Advanced Matching"): Nutzerdaten an den Browser-Pixel geben,
 * bevor das Event feuert. Ohne das trägt das Browser-Event nur Cookies, während das
 * Server-Event E-Mail, Telefon und Name mitschickt — Meta kann beide dann schlechter
 * als dasselbe Ereignis erkennen. Der Pixel hasht die Werte selbst mit SHA-256,
 * bevor er sie überträgt; im Klartext verlässt nichts den Browser.
 */
export function setMetaUserData({ email, telefon, vorname, nachname, ort, externalId }) {
  if (!window.fbq || !loadedPixelId) return false;
  const digits = (telefon || '').replace(/[^0-9+]/g, '')
    .replace(/^00/, '+').replace(/^\+/, '')
    .replace(/^0/, '49');
  const norm = (v) => (v || '').trim().toLowerCase() || undefined;
  const daten = {
    em: norm(email),
    ph: digits.length >= 8 ? digits : undefined,
    fn: norm(vorname),
    ln: norm(nachname),
    ct: norm(ort)?.replace(/[^a-zäöüß]/g, '') || undefined,
    country: 'de',
    external_id: externalId || undefined,
  };
  Object.keys(daten).forEach(k => daten[k] === undefined && delete daten[k]);
  window.fbq('init', loadedPixelId, daten);
  return true;
}

/** Standard event with dedup id (e.g. 'Lead'). */
export function trackPixelEvent(eventName, params = {}, eventId) {
  if (!window.fbq) return false;
  window.fbq('track', eventName, params, eventId ? { eventID: eventId } : undefined);
  return true;
}

/** Seitenaufruf melden — fuer Wechsel innerhalb der Anwendung ohne Neuladen. */
export function trackPixelPageView(eventId) {
  if (!window.fbq) return false;
  if (eventId) window.fbq('track', 'PageView', {}, { eventID: eventId });
  else window.fbq('track', 'PageView');
  return true;
}

/** Custom event (no CAPI counterpart needed). */
export function trackPixelCustom(eventName, params = {}) {
  if (!window.fbq) return false;
  window.fbq('trackCustom', eventName, params);
  return true;
}

export function readCookie(name) {
  try {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  } catch { return ''; }
}

/** _fbc / _fbp cookies set by the pixel; builds _fbc from fbclid if the cookie isn't there yet. */
export function getMetaBrowserIds(fbclid) {
  let fbc = readCookie('_fbc');
  const fbp = readCookie('_fbp');
  if (!fbc && fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
  return { fbc, fbp };
}

export function generateEventId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'ev_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
}
